<script>
import { mapGetters } from 'vuex';
import validations from './helpers/validations';
import FormInput from 'v3/components/Form/Input.vue';
import { reactive } from 'vue';
import { useSectorlessAccount } from 'dashboard/composables/useSectorlessAccount';
import { useVuelidate } from '@vuelidate/core';

import NextButton from 'dashboard/components-next/button/Button.vue';

export default {
  components: {
    NextButton,
    FormInput,
  },
  props: {
    onSubmit: {
      type: Function,
      default: () => {},
    },
    submitInProgress: {
      type: Boolean,
      default: false,
    },
    formData: {
      type: Object,
      default: () => {},
    },
    submitButtonText: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGetters({
      sectors: 'sectors/getSectors',
    }),
  },
  created() {
    this.$store.dispatch('sectors/get');
  },
  setup(props) {
    const { isSectorlessAccount } = useSectorlessAccount();
    const formData = props.formData || {};
    const {
      description = '',
      name: title = '',
      allow_auto_assign: allowAutoAssign = true,
      sector_id: sectorId = null,
    } = formData;

    const state = reactive({
      description,
      title,
      allowAutoAssign,
      sectorId,
    });

    const rules = validations;
    const v$ = useVuelidate(rules, state);
    return { state, v$, isSectorlessAccount };
  },
  methods: {
    handleSubmit() {
      this.v$.$touch();
      if (this.v$.$invalid) {
        return;
      }
      this.onSubmit({
        description: this.state.description,
        name: this.state.title,
        allow_auto_assign: this.state.allowAutoAssign,
        ...(!this.isSectorlessAccount
          ? { sector_id: this.state.sectorId || null }
          : {}),
      });
    },
  },
};
</script>

<template>
  <div class="flex-shrink-0 w-full">
    <form class="mx-0 grid gap-4" @submit.prevent="handleSubmit">
      <FormInput
        v-model="state.title"
        name="title"
        spacing="compact"
        :label="$t('TEAMS_SETTINGS.FORM.NAME.LABEL')"
        :placeholder="$t('TEAMS_SETTINGS.FORM.NAME.PLACEHOLDER')"
        :has-error="v$.title.$error"
        :error-message="v$.title.$error ? v$.title.$errors[0].$message : ''"
        @blur="v$.title.$touch"
      />
      <FormInput
        v-model="state.description"
        name="description"
        spacing="compact"
        :label="$t('TEAMS_SETTINGS.FORM.DESCRIPTION.LABEL')"
        :placeholder="$t('TEAMS_SETTINGS.FORM.DESCRIPTION.PLACEHOLDER')"
        :has-error="v$.description.$error"
        :error-message="
          v$.description.$error ? v$.description.$errors[0].$message : ''
        "
        @blur="v$.description.$touch"
      />
      <div v-if="!isSectorlessAccount" class="w-full">
        <label class="block text-sm font-medium text-n-slate-12 mb-1">
          {{ $t('TEAMS_SETTINGS.FORM.SECTOR.LABEL') }}
        </label>
        <select
          v-model="state.sectorId"
          class="w-full border border-n-weak rounded-lg px-3 py-2 text-sm bg-n-alpha-2 text-n-slate-12"
        >
          <option :value="null">
            {{ $t('TEAMS_SETTINGS.FORM.SECTOR.PLACEHOLDER') }}
          </option>
          <option
            v-for="sector in sectors"
            :key="sector.id"
            :value="sector.id"
          >
            {{ sector.name }}
          </option>
        </select>
      </div>
      <div class="w-full flex items-center gap-2">
        <input v-model="state.allowAutoAssign" type="checkbox" :value="true" />
        <label for="conversation_creation">
          {{ $t('TEAMS_SETTINGS.FORM.AUTO_ASSIGN.LABEL') }}
        </label>
      </div>
      <div class="flex flex-row justify-end gap-2 py-2 px-0 w-full">
        <div class="w-full">
          <NextButton
            type="submit"
            :label="submitButtonText"
            :disabled="v$.title.$invalid || submitInProgress"
            :is-loading="submitInProgress"
          />
        </div>
      </div>
    </form>
  </div>
</template>
